import BotMonitoring from "./BotMonitoring.component";

export default BotMonitoring;
